import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';
import Home from './views/Home.vue'
const NotFoundComponent = () => import('./views/NotFoundComponent.vue')
const About = () => import('./views/About.vue')
const Kaisha = () => import('./views/Kaisha.vue')
const KaishaEng = () => import('./views/KaishaEng.vue')
const Faq = () => import('./views/Faq.vue')
const FaqEng = () => import('./views/FaqEng.vue')
const Products = () => import('./views/Products.vue')
const ProductsEng = () => import('./views/ProductsEng.vue')
const Support = () => import('./views/Support.vue')
const SupportEng = () => import('./views/SupportEng.vue')
const News = () => import('./views/News.vue')
const Saiyo = () => import('./views/Saiyo.vue')
const Pro55 = () => import('./views/Pro55.vue')
const Pro35 = () => import('./views/Pro35.vue')
const PL400ne = () => import('./views/PL400ne.vue')
const Smartdren = () => import('./views/Smartdren.vue')
const SmartdrenDual = () => import('./views/SmartdrenDual.vue')
const SlimmingWave = () => import('./views/SlimmingWave.vue')
const HM = () => import('./views/HM.vue')
const DrPROHS = () => import('./views/DrPROHS.vue')
const DrPRO = () => import('./views/DrPRO.vue')
const DrPROEng = () => import('./views/DrPROEng.vue')
const DrPROSLIMEng = () => import('./views/DrPROSLIMEng.vue')
const EvolutionSlim = () => import('./views/EvolutionSlim.vue')
const EvolutionCarving = () => import('./views/EvolutionCarving.vue')
const MagBladeEng = () => import('./views/MagBladeEng.vue')
const BeautyJetEng = () => import('./views/BeautyJetEng.vue')
const Cosmetics = () => import('./views/Cosmetics.vue')
const CosmeticsEng = () => import('./views/CosmeticsEng.vue')
const PLcosmetics = () => import('./views/PLcosmetics.vue')
const PLcosmeticsEng = () => import('./views/PLcosmeticsEng.vue')
const ACcosmetics = () => import('./views/ACcosmetics.vue')
const ACcosmeticsEng = () => import('./views/ACcosmeticsEng.vue')
const HMcosmetics = () => import('./views/HMcosmetics.vue')
const HMcosmeticsEng = () => import('./views/HMcosmeticsEng.vue')
const SUNKISSEDSkin = () => import('./views/SUNKISSEDSkin.vue')
const Biganki = () => import('./views/Biganki.vue')
const Catalog = () => import('./views/Catalog.vue')
const Posters = () => import('./views/Posters.vue')
const Contact = () => import('./views/Contact.vue')
const ContactEng = () => import('./views/ContactEng.vue')
const Taiken = () => import('./views/Taiken.vue')
const TaikenEng = () => import('./views/TaikenEng.vue')
const Fuguai = () => import('./views/Fuguai.vue')
const Chumon = () => import('./views/Chumon.vue')
const ChumonSanbiso = () => import('./views/ChumonSanbiso.vue')
const ChumonGlobva = () => import('./views/ChumonGlobva.vue')
const ChumonAlfine = () => import('./views/ChumonAlfine.vue')
const ChumonFelizDia = () => import('./views/ChumonFelizDia.vue')
const ChumonAnge = () => import('./views/ChumonAnge.vue')
const ChumonCuts = () => import('./views/ChumonCuts.vue')
const ChumonKyu = () => import('./views/ChumonKyu.vue')
const ChumonSkon = () => import('./views/ChumonSkon.vue')
const ChumonSankyo = () => import('./views/ChumonSankyo.vue')
const ChumonMoreRose = () => import('./views/ChumonMoreRose.vue')
const ChumonFunnyBee = () => import('./views/ChumonFunnyBee.vue')
const ChumonRevoir = () => import('./views/ChumonRevoir.vue')
const ChumonHilo = () => import('./views/ChumonHilo.vue')
const ChumonKumiko = () => import('./views/ChumonKumiko.vue')
const ChumonLuxe = () => import('./views/ChumonLuxe.vue')
const ChumonTierra = () => import('./views/ChumonTierra.vue')
const ChumonAlmare = () => import('./views/ChumonAlmare.vue')
const ChumonFesti = () => import('./views/ChumonFesti.vue')
const ChumonKoubi = () => import('./views/ChumonKoubi.vue')
const ChumonLeaf = () => import('./views/ChumonLeaf.vue')
const ChumonGlanz = () => import('./views/ChumonGlanz.vue')
const ChumonByuNature = () => import('./views/ChumonByuNature.vue')
const ChumonOmoromachi = () => import('./views/ChumonOmoromachi.vue')
const ChumonTusais = () => import('./views/ChumonTusais.vue')
const ChumonFutureBrain = () => import('./views/ChumonFutureBrain.vue')
const ChumonRosso = () => import('./views/ChumonRosso.vue')
const ChumonOfficeCOCO = () => import('./views/ChumonOfficeCOCO.vue')
const ChumonCosmo = () => import('./views/ChumonCosmo.vue')
const ChumonAsahi = () => import('./views/ChumonAsahi.vue')
const ChumonCosmeClinic = () => import('./views/ChumonCosmeClinic.vue')
const MonitorTouroku = () => import('./views/MonitorTouroku.vue')
const Login = () => import('./views/Login.vue')
const Register = () => import('./views/Register.vue')
const Register2 = () => import('./views/Register2.vue')
const UserPage = () => import('./views/UserPage.vue')
const NefgUDaVjiUmSBJwYu0Q = () => import('./views/NefgUDaVjiUmSBJwYu0Q.vue')
const zYtJA0BAhTATJCHRkEKl = () => import('./views/zYtJA0BAhTATJCHRkEKl.vue')
const ntf3WGU1NXhNqPM64BFc = () => import('./views/ntf3WGU1NXhNqPM64BFc.vue')
const bYD1yVVAswugQetLbplk = () => import('./views/bYD1yVVAswugQetLbplk.vue')
const EditProfile = () => import('./views/EditProfile.vue')
const Mask = () => import('./views/Mask.vue')
const BW2019 = () => import('./views/BW2019.vue')
const Sugaring = () => import('./views/Sugaring.vue')
const SugaringSeminar = () => import('./views/SugaringSeminar.vue')
const BeautySpecialistAward = () => import('./views/BeautySpecialistAward.vue')
const Saiyo2020 = () => import('./views/Saiyo2020.vue')
const News210524 = () => import('./views/News210524.vue')
const News211004 = () => import('./views/News211004.vue')
const News211110 = () => import('./views/News211110.vue')
const News220111 = () => import('./views/News220111.vue')
const News220202 = () => import('./views/News220202.vue')
const News220511 = () => import('./views/News220511.vue')
const News230125BWF = () => import('./views/News230125BWF.vue')
const NewsBWF2025 = () => import('./views/NewsBWF2025.vue')
const News230125GS = () => import('./views/News230125GS.vue')
const News230501 = () => import('./views/News230501.vue')
const News230712BWN = () => import('./views/News230712BWN.vue')
const News231005 = () => import('./views/News231005.vue')
const News231018 = () => import('./views/News231018.vue')
const News250401 = () => import('./views/NewsBW2025tokyo.vue')
const News250714 = () => import('./views/NewsBW2025nagoya.vue')
const News251020 = () => import('./views/NewsBW2025osaka.vue')
const News250714Eng = () => import('./views/NewsBW2025nagoyaEng.vue')
const News251020Eng = () => import('./views/NewsBW2025osakaEng.vue')
const News20251226 = () => import('./views/News20251226.vue')
const News20251226ENG = () => import('./views/News20251226ENG.vue')
const OnlineStore = () => import('./views/OnlineStore.vue')
const OnlineStoreEng = () => import('./views/OnlineStoreEng.vue')
const News240724BWN = () => import('./views/News240724BWN.vue')
const HomeEng = () => import('./views/HomeEng.vue')


Vue.use(Router)

let router = new Router({
    mode: 'history',

    // https://router.vuejs.org/guide/advanced/scroll-behavior.html
    scrollBehavior (to, from, savedPosition) {
        return { x: 0, y: 0 }
    },
    routes: [
        { path: '*', component: NotFoundComponent },
        { path: '/', name: 'home', component: Home },
        { path: '/en', name: 'homeeng', component: HomeEng },
        { path: '/about', name: 'about', component: About },
        { path: '/kaisha', name: 'kaisha', component: Kaisha },
        { path: '/en/kaisha', name: 'kaishaeng', component: KaishaEng },
        { path: '/faq', name: 'faq', component: Faq },
        { path: '/en/faq', name: 'faqeng', component: FaqEng },
        { path: '/products', name: 'products', component: Products },
        { path: '/en/products', name: 'productseng', component: ProductsEng },
        { path: '/support', name: 'support', component: Support },
        { path: '/en/support', name: 'supporteng', component: SupportEng },
        { path: '/news', name: 'news', component: News },
        { path: '/saiyo', name: 'saiyo', component: Saiyo },
        { path: '/saiyo2020', name: 'saiyo2020', component: Saiyo2020 },
        { path: '/pro55', name: 'pro55', component: Pro55 },
        { path: '/pro35', name: 'pro35', component: Pro35 },
        { path: '/pl400ne', name: 'pl400ne', component: PL400ne },
        { path: '/smartdren', name: 'smartdren', component: Smartdren },
        { path: '/smartdrendual', name: 'smartdrendual', component: SmartdrenDual },
        { path: '/slimmingwave', name: 'slimmingwave', component: SlimmingWave },
        { path: '/hm', name: 'hm', component: HM },
        { path: '/drprohs', name: 'drprohs', component: DrPROHS },
        { path: '/drpro', name: 'drpro', component: DrPRO },
        { path: '/en/drpro', name: 'drproeng', component: DrPROEng },
        { path: '/en/drproslim', name: 'drproslimeng', component: DrPROSLIMEng },
        { path: '/evoslim', name: 'evoslim', component: EvolutionSlim },
        { path: '/evocarving', name: 'evocarving', component: EvolutionCarving },
        { path: '/en/magblade', name: 'magbladeeng', component: MagBladeEng },
        { path: '/en/beautyjet', name: 'beautyjeteng', component: BeautyJetEng },
        { path: '/cosmetics', name: 'cosmetics', component: Cosmetics },
        { path: '/en/cosmetics', name: 'cosmeticseng', component: CosmeticsEng },
        { path: '/plcosmetics', name: 'plcosmetics', component: PLcosmetics },
        { path: '/en/plcosmetics', name: 'plcosmeticseng', component: PLcosmeticsEng },
        { path: '/accosmetics', name: 'accosmetics', component: ACcosmetics },
        { path: '/en/accosmetics', name: 'accosmeticseng', component: ACcosmeticsEng },
        { path: '/hmcosmetics', name: 'hmcosmetics', component: HMcosmetics },
        { path: '/en/hmcosmetics', name: 'hmcosmeticseng', component: HMcosmeticsEng },
        { path: '/sunkissedskin', name: 'sunkissedskin', component: SUNKISSEDSkin },
        { path: '/biganki', name: 'biganki', component: Biganki },
        { path: '/catalog', name: 'catalog', component: Catalog },
        { path: '/posters', name: 'posters', component: Posters, meta: { requiresAuth: true } },
        { path: '/contact', name: 'contact', component: Contact },
        { path: '/en/contact', name: 'contacteng', component: ContactEng },
        { path: '/taiken', name: 'taiken', component: Taiken },
        { path: '/en/taiken', name: 'taikeneng', component: TaikenEng },
        { path: '/fuguai', name: 'fuguai', component: Fuguai },
        { path: '/monitortouroku', name: 'monitortouroku', component: MonitorTouroku },
        { path: '/login', name: 'login', component: Login },
        { path: '/register', name: 'register', component: Register },
        { path: '/register2', name: 'register2', component: Register2 },
        { path: '/userpage', name: 'userpage', component: UserPage, meta: { requiresAuth: true } },
        { path: '/NefgUDaVjiUmSBJwYu0Q', name: 'NefgUDaVjiUmSBJwYu0Q', component: NefgUDaVjiUmSBJwYu0Q, meta: { requiresAuth: true } },
        { path: '/zYtJA0BAhTATJCHRkEKl', name: 'zYtJA0BAhTATJCHRkEKl', component: zYtJA0BAhTATJCHRkEKl, meta: { requiresAuth: true } },
        { path: '/ntf3WGU1NXhNqPM64BFc', name: 'ntf3WGU1NXhNqPM64BFc', component: ntf3WGU1NXhNqPM64BFc, meta: { requiresAuth: true } },
        { path: '/bYD1yVVAswugQetLbplk', name: 'bYD1yVVAswugQetLbplk', component: bYD1yVVAswugQetLbplk, meta: { requiresAuth: true } },
        { path: '/chumon', name: 'chumon', component: Chumon, meta: { requiresAuth: true } },
        { path: '/chumonsanbiso', name: 'chumonsanbiso', component: ChumonSanbiso, meta: { requiresAuth: true } },
        { path: '/chumonglobva', name: 'chumonglobva', component: ChumonGlobva, meta: { requiresAuth: true } },
        { path: '/chumonalfine', name: 'chumonalfine', component: ChumonAlfine, meta: { requiresAuth: true } },
        { path: '/chumonfelizdia', name: 'chumonfelizdia', component: ChumonFelizDia, meta: { requiresAuth: true } },
        { path: '/chumonange', name: 'chumonange', component: ChumonAnge, meta: { requiresAuth: true } },
        { path: '/chumoncuts', name: 'chumoncuts', component: ChumonCuts, meta: { requiresAuth: true } },
        { path: '/chumonkyu', name: 'chumonkyu', component: ChumonKyu, meta: { requiresAuth: true } },
        { path: '/chumonskon', name: 'chumonskon', component: ChumonSkon, meta: { requiresAuth: true } },
        { path: '/chumonsankyo', name: 'chumonsankyo', component: ChumonSankyo, meta: { requiresAuth: true } },
        { path: '/chumonmorerose', name: 'chumonmorerose', component: ChumonMoreRose, meta: { requiresAuth: true } },
        { path: '/chumonfunnybee', name: 'chumonfunnybee', component: ChumonFunnyBee, meta: { requiresAuth: true } },
        { path: '/chumonrevoir', name: 'chumonrevoir', component: ChumonRevoir, meta: { requiresAuth: true } },
        { path: '/chumonhilo', name: 'chumonhilo', component: ChumonHilo, meta: { requiresAuth: true } },
        { path: '/chumonkumiko', name: 'chumonkumiko', component: ChumonKumiko, meta: { requiresAuth: true } },
        { path: '/chumonluxe', name: 'chumonluxe', component: ChumonLuxe, meta: { requiresAuth: true } },
        { path: '/chumontierra', name: 'chumontierra', component: ChumonTierra, meta: { requiresAuth: true } },
        { path: '/chumonalmare', name: 'chumonalmare', component: ChumonAlmare, meta: { requiresAuth: true } },
        { path: '/chumonalmare', name: 'chumonalmare', component: ChumonAlmare, meta: { requiresAuth: true } },
        { path: '/chumonfesti', name: 'chumonfesti', component: ChumonFesti, meta: { requiresAuth: true } },
        { path: '/chumonkoubi', name: 'chumonkoubi', component: ChumonKoubi, meta: { requiresAuth: true } },
        { path: '/chumonleaf', name: 'chumonleaf', component: ChumonLeaf, meta: { requiresAuth: true } },
        { path: '/chumonglanz', name: 'chumonglanz', component: ChumonGlanz, meta: { requiresAuth: true } },
        { path: '/chumonbyunature', name: 'chumonbyunature', component: ChumonByuNature, meta: { requiresAuth: true } },
        { path: '/chumonomoromachi', name: 'chumonomoromachi', component: ChumonOmoromachi, meta: { requiresAuth: true } },
        { path: '/chumontusais', name: 'chumontusais', component: ChumonTusais, meta: { requiresAuth: true } },
        { path: '/chumonfuturebrain', name: 'chumonfuturebrain', component: ChumonFutureBrain, meta: { requiresAuth: true } },
        { path: '/chumonrosso', name: 'chumonrosso', component: ChumonRosso, meta: { requiresAuth: true } },
        { path: '/chumonofficecoco', name: 'chumonofficecoco', component: ChumonOfficeCOCO, meta: { requiresAuth: true } },
        { path: '/chumoncosmo', name: 'chumoncosmo', component: ChumonCosmo, meta: { requiresAuth: true } },
        { path: '/chumonasahi', name: 'chumonasahi', component: ChumonAsahi, meta: { requiresAuth: true } },
        { path: '/chumoncosmeclinic', name: 'chumoncosmeclinic', component: ChumonCosmeClinic, meta: { requiresAuth: true } },
        { path: '/editprofile', name: 'editprofile', component: EditProfile },
        { path: '/mask', name: 'mask', component: Mask },
        { path: '/bw2019', name: 'bw2019', component: BW2019 },
        { path: '/sugaring', name: 'sugaring', component: Sugaring },
        { path: '/sugaringseminar', name: 'sugaringseminar', component: SugaringSeminar },
        { path: '/BeautySpecialistAward', name: 'BeautySpecialistAward', component: BeautySpecialistAward },
        { path: '/news210524', name: 'news210524', component: News210524 },
        { path: '/news211004', name: 'news211004', component: News211004 },
        { path: '/news211110', name: 'news211110', component: News211110 },
        { path: '/news220111', name: 'news220111', component: News220111 },
        { path: '/news220202', name: 'news220202', component: News220202 },
        { path: '/news220511', name: 'news220511', component: News220511 },
        { path: '/news230125bwf', name: 'news230125bwf', component: News230125BWF },
        { path: '/newsBWF2025', name: 'newsBWF2025', component: NewsBWF2025 },
        { path: '/news230125gs', name: 'news230125gs', component: News230125GS },
        { path: '/news230501', name: 'news230501', component: News230501 },
        { path: '/news230712bwn', name: 'news230712bwn', component: News230712BWN },
        { path: '/news231005', name: 'news231005', component: News231005 },
        { path: '/news231018', name: 'news231018', component: News231018 },
        { path: '/news250401', name: 'news250401', component: News250401 },
        { path: '/news250714', name: 'news250714', component: News250714 },
        { path: '/news251020', name: 'news251020', component: News251020 },
        { path: '/en/news250714en', name: 'news250714en', component: News250714Eng },
        { path: '/en/news251020en', name: 'news251020en', component: News251020Eng },
 	{ path: '/news20251226', name: 'news20251226', component: News20251226 },
	{ path: '/en/news20251226', name: 'news20251226eng', component: News20251226ENG },
        { path: '/onlinestore', name: 'onlinestore', component: OnlineStore },
        { path: '/en/onlinestore', name: 'onlinestoreeng', component: OnlineStoreEng },
        { path: '/news240724bwn', name: 'news240724bwn', component: News240724BWN }
    ]
});


// Nav Guard
router.beforeEach((to, from, next) => {
  // Check for requiresAuth guard
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // Check if NO logged user
    if (!firebase.auth().currentUser) {
      // Go to login
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      });
    } else {
      // Proceed to route
      next();
    }
  } else if (to.matched.some(record => record.meta.requiresGuest)) {
    // Check if NO logged user
    if (firebase.auth().currentUser) {
      // Go to login
      next({
        path: '/',
        query: {
          redirect: to.fullPath
        }
      });
    } else {
      // Proceed to route
      next();
    }
  } else {
    // Proceed to route
    next();
  }
});

// https://qiita.com/tiwu_official/items/eeaa1424ca757362e836
router.afterEach((to, from) => {
  gtag('config', 'G-QC7DMB5SSL', {'page_path': to.path});
})

export default router;
